// Импорт как ES-модуль
import axios from 'axios';
import qs from 'qs';
import { decode } from 'jsonwebtoken';

// Типы действий (ActionTypes)
export const LOGIN = 'auth/LOGIN';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'auth/LOGIN_ERROR';

const REFRESH_LOGIN_SUCCESS = 'auth/REFRESH_LOGIN_SUCCESS';
const GET_CACHED_DATA_SUCCESS = 'auth/GET_CACHED_DATA_SUCCESS';

// Имена для хранения данных в localStorage
const CACHE_NAME = process.env.REACT_APP_AUTH_CACHE_NAME;
const CACHE_OUTER_NAME = process.env.REACT_APP_AUTH_OUTER_CACHE_NAME;
const CACHE_REDIRECT_PATH_NAME = process.env.REACT_APP_AUTH_REDIRECT_PATH_CACHE_NAME;

// Экземпляр axios для работы с API аутентификации
export const instance = axios.create({
  baseURL: process.env.REACT_APP_AUTH_BASE_URL,
  timeout: 90000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

// Отдельный экземпляр axios для IRTECH API
const irtechInstance = axios.create({
  baseURL: process.env.REACT_APP_AUTH_BASE_URL_IRTECH,
  timeout: 90000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Начальное состояние для редьюсера
const initialState = {
  isLoading: false,
  data: {},
  error: null,
  errorText: '',
  reasonBlock: ''
};

// Редьюсер - чистая функция, которая изменяет состояние в зависимости от action
export function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN:
      return { ...state, isLoading: true, error: null };

    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: {
          user: decode(action.payload.access_token)
        }
      };

    case LOGIN_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        errorText: action.errorText,
        reasonBlock: action.reasonBlock
      };

    default:
      return state;
  }
}

// Функция для сохранения данных аутентификации в localStorage
function save(data) {
  if (CACHE_NAME) {
    localStorage.setItem(CACHE_NAME, JSON.stringify({
      ...data,
      expires_in: Date.now() / 1000 + data.expires_in,
      refresh_expires_in: Date.now() / 1000 + data.refresh_expires_in,
    }));
  } else {
    console.warn('Cache save: "REACT_APP_AUTH_CACHE_NAME" env. не определена');
  }
}

// Функция для сохранения внешних токенов в localStorage
function saveOuter(data) {
  if (CACHE_OUTER_NAME) {
    localStorage.setItem(CACHE_OUTER_NAME, JSON.stringify({
      ...data,
      expires_in: Date.now() / 1000 + data.expires_in,
      refresh_expires_in: Date.now() / 1000 + data.refresh_expires_in,
    }));
  } else {
    console.warn('Cache save: "REACT_APP_AUTH_OUTER_CACHE_NAME" env. не определена');
  }
}

export function getValidOuterToken() {
  if (!CACHE_OUTER_NAME) return null;

  const stored = localStorage.getItem(CACHE_OUTER_NAME);
  if (!stored) return null;

  try {
    const data = JSON.parse(stored);
    const now = Date.now() / 1000;

    if (data.expires_in && now >= data.expires_in) {
      console.warn('Срок действия токена истек');
      return null;
    }

    return data.access_token || null;
  } catch (e) {
    console.error('Не удалось проанализировать внешний токен: ', e);
    return null;
  }
}

function clearOuterToken() {
  if (CACHE_OUTER_NAME) {
    localStorage.removeItem(CACHE_OUTER_NAME);
  }
}

// Сохранение пути редиректа
function saveRedirectPath(pathname) {
  console.log('saveRedirectPath', pathname, CACHE_REDIRECT_PATH_NAME);
  const nowInSeconds = Date.now() / 1000;
  if (CACHE_REDIRECT_PATH_NAME) {
    localStorage.setItem(CACHE_REDIRECT_PATH_NAME, JSON.stringify({
      pathname,
      expires_in: nowInSeconds + 20,
    }));
  } else {
    console.warn('Cache save: "REACT_APP_AUTH_REDIRECT_PATH_CACHE_NAME" env. не определена');
  }
}

// Action creator для логина - возвращает thunk (функцию для middleware)
export function login(payload) {
  console.log('!! login payload', payload);
  return function (dispatch) {
    console.log('!!! return login dispatch: ', dispatch, '_ payload _: ', payload);
    dispatch({ type: LOGIN });
    return instance.post('', qs.stringify({
      grant_type: 'password',
      client_id: process.env.REACT_APP_AUTH_CLIENT_ID,
      ...payload
    }))
      .then(function (response) {
        console.log('!!!! login then', response);
        const action = { type: LOGIN_SUCCESS, payload: response.data };
        dispatch(action);
        saveAuthData(action);
      })
      .catch(function (error) {
        console.log('!!!! login error', error);
        const action = {
          type: LOGIN_ERROR,
          error: error.response && error.response.status,
          errorText: error.response && error.response.data && error.response.data.error_description,
          reasonBlock: error.response && error.response.data && error.response.data.reason_block
        };
        dispatch(action);
      });
  };
}

// Новый action creator для логина по коду
export function loginCode(token, location) {
  const pathname = location && location.pathname;
  const href = location && location.href && location.href.split('?')[0];
  console.log('!! loginCode token', token);
  return function (dispatch) {
    console.log('!!! return loginCode dispatch: ', dispatch, '_ token _: ', token);
    dispatch({ type: LOGIN });
    return irtechInstance.post('', {
      code: token,
      grant_type: 'password',
      redirect_uri: href
    })
      .then(function (response) {
        console.log('!!!! loginCode then', response);
        saveRedirectPath(pathname);
        if (response.data && response.data.outter) {
          console.log('!!!! Outer:', response.data.outter);
          saveOuter(response.data.outter);
        }
        if (response.data && response.data.inner) {
          const action = { type: LOGIN_SUCCESS, payload: response.data.inner };
          dispatch(action);
          saveAuthData(action);
        } else {
          throw new Error('Inner token not found in response');
        }
      })
      .catch(function (error) {
        console.log('!!!! loginCode error', error);
        const action = {
          type: LOGIN_ERROR,
          error: error.response && error.response.status,
          errorText: error.response && error.response.data && error.response.data.error_description,
          reasonBlock: error.response && error.response.data && error.response.data.reason_block
        };
        dispatch(action);
      });
  };
}

// Функция для обработки данных аутентификации (вызывается после dispatch)
export function saveAuthData(action) {
  console.log('!!!! saveAuthData action:', action);
  switch (action.type) {
    case LOGIN_SUCCESS:
    case REFRESH_LOGIN_SUCCESS:
    case GET_CACHED_DATA_SUCCESS:
      instance.defaults.headers.common['Authorization'] = `Bearer ${action.payload.access_token}`;
      save(action.payload);
      break;
    default:
      break;
  }
}